import React, { useEffect, useRef, useState } from "react";
import { Button, Form } from "antd";
import GeneralDetails from "../Components/GeneralDetails";
import './RequestFeedbackForm.css'
import { DataProvider } from "../../DataProvider";
import { openNotification } from "swfrontend/COMS/NotificationMessageMapping";
import ProgressModal from "../../../App/Utils/ProgressModal";

const RequestFeedbackForm = ({ history }) => {
    const dataProvider = new DataProvider();
    const formRef = useRef();
    const [form] = Form.useForm();
    const [showProgress, setShowProgress] = useState(false);
    const [state, setState] = useState({
        currentStep: 0,
    });

    useEffect(() => { }, [showProgress])

    const onFinish = (values) => {
        setShowProgress(true);
        const formData = new FormData()
        
        if(!values.hasOwnProperty('section_head')){
            values['section_head'] = "[]"
        }
        
        const contractorDetails = JSON.parse(values['contractor_name'])
        values['contractor_code'] = contractorDetails['key']
        
        values['evaluation_period'] = values['evaluation_period'].format('YYYY-MM-DD')

        const payload = {
            'feedback_general_data': values,
        }
        formData.append('data', JSON.stringify(payload))
        dataProvider.requestFeedback(formData)
            .then(response => {
                setShowProgress(false);
                if (response.ok) {
                    response.json().then(responseJson => {
                        openNotification("success", "Success", responseJson["message"])
                        history.replace('/ViewFeedback/' + responseJson['id'])
                    })
                } else {
                    response.json().then(responseJson => {
                        openNotification("error", "Error", responseJson["message"])
                    })
                }
            }).catch(error => {
                openNotification("error", "Error", "Error connecting server")
                setShowProgress(false);
            })
    };


    useEffect(() => { }, [state]);

    return (
        <>
            <ProgressModal showProgress={showProgress} />
            <Form
                ref={formRef}
                className="ant-form ant-form-vertical"
                onFinish={onFinish}
                scrollToFirstError={true}
                form={form}
                encType="multipart/form-data"
            >
                <div className="row form-box" style={{paddingTop:"10px"}}>
                    <GeneralDetails formRef={formRef}  />
                </div>
                <div style={{ textAlign: "right", marginRight: "15px" }}>
                    <Button
                        htmlType="submit"
                        type="primary">Submit
                    </Button>
                </div>
            </Form>
        </>
    );
};

export default RequestFeedbackForm;
